const highlightsText = `
Terms and Conditions Pending...
`;

export default highlightsText;